import { apiPostAuth, apiGetAuth, apiPutAuth, apiDeleteAuth } from '@/utils/api'
import { API_REPORT } from '@/utils/api-url'
import {
  notificationDanger
} from '@/utils/notification'

const state = {
  report_list: { 
    isLoading: false,
    data: {}
  },
  detail_report: {
    isLoading: false,
    data: {}
  },
  data_modal_add_edit: {},
  toggle_modal_add_edit_discard: {
    targetModals: false,  
    title: '',
    description: '',
    type: '',
    customTitleBtnOk: '',
    customTitleBtnCancel: '',
    customClass: '',
    loadingTable: false,
    loadingPopUp: false
  },
  detail_modal_preview: {},
  meta_filter: {
    order_by: 'created_at',
    sort_by: 'desc'
  }
}

const mutations = {
  "SET_REPORT_LIST": (state, payload) => {
    state.report_list = payload
  },
  "SET_DETAIL_REPORT": (state, payload) => {
    state.detail_report = payload
  },
  "SET_DATA_MODAL_ADD_EDIT": (state, payload) => {
    state.data_modal_add_edit = payload
  },
  "SET_TOGGLE_MODAL_ADD_EDIT_DISCARD": (state, payload) => {
    state.toggle_modal_add_edit_discard = payload
  },
  "SET_DETAIL_MODAL_PREVIEW": (state, payload) => {
    state.detail_modal_preview = payload
  },
  "SET_META_FILTER": (state, payload) => {
    state.meta_filter = payload
  }
}

const actions = {
  async getReportList(context, payload) {
    try {
      context.commit('SET_REPORT_LIST', { isLoading: true })
      const response = await apiGetAuth(API_REPORT.LIST, payload)
      context.commit('SET_REPORT_LIST', {
        isLoading: false,
        data: response.data
      })
    } catch (err) {
      context.commit('SET_REPORT_LIST', {
        isLoading: false,
        data: false
      })
      notificationDanger(err)
    }
  },
  async getDetailReport (context, payload) {
    try {
      context.commit('SET_DETAIL_REPORT', { isLoading: true })
      const response = await apiGetAuth(API_REPORT.BY_ID(payload))
      context.commit('SET_DETAIL_REPORT', {
        isLoading: false,
        data: response.data
      })
    } catch (error) {
      context.commit('SET_DETAIL_REPORT', {
        isLoading: false,
        data: false
      })
      notificationDanger(error)
    }
  },
  async createReport (context, payload) {
    try {
      const response = await apiPostAuth(API_REPORT.CREATE_REPORT, payload)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async updateReport (context, payload) {
    try {
      const response = await apiPutAuth(API_REPORT.BY_ID(payload.id), payload.reqBody)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async deleteReport (context, payload) {
    try {
      const response = await apiDeleteAuth(API_REPORT.BY_ID(payload))
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  }
}

const getters = {
  get_report_list: state => {
    return state.report_list
  },
  get_detail_report: state => {
    return state.detail_report
  },
  get_data_modal_add_edit: state => {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard: state => {
    return state.toggle_modal_add_edit_discard
  },
  get_detail_modal_preview: state => {
    return state.detail_modal_preview
  },
  meta_filter: state => {
    return state.meta_filter
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
